import { useContext } from 'react';
import { AriaLiveContext } from '../context/AriaLiveProvider';
export default (function () {
    return useContext(AriaLiveContext);
});
//# sourceMappingURL=useAriaLive.js.map